import { Clock } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

export const WaitingForResponse = ({ message }: { message: string }) => (
  <Alert className="mt-4 mb-10">
    <Clock />
    <AlertDescription>{message}</AlertDescription>
  </Alert>
);
